import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconShapeCross, IconCoreSearch } from '@xingternal/malt-icon';
import { injectIntl, intlShape } from 'react-intl';
import { ttt } from '@xingternal/malt-tracking';
import { withFlavourCSS } from '@xingternal/flavour';

import { base, odl, xdl } from './flavours';

class SearchInput extends Component {
  static displayName = 'SearchInput';

  static defaultProps = {
    isOpened: false,
  };

  static propTypes = {
    className: PropTypes.string,
    query: PropTypes.string,
    triggerInput: PropTypes.func.isRequired,
    isOpened: PropTypes.bool,
    activate: PropTypes.func.isRequired,
    deactivate: PropTypes.func.isRequired,
    intl: intlShape,
    searchLink: PropTypes.func.isRequired,
    getInputProps: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
    highlightedIndex: PropTypes.number,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  };

  queryEl = null;

  state = {
    isTypingTracked: false,
  };

  handleChange = () => {
    if (this.props.triggerInput) {
      this.props.triggerInput(this.queryEl ? this.queryEl.value : '');
      // track start of the typing (only for the first time per search field active)
      if (!this.state.isTypingTracked) {
        ttt.event('PropTrackAction', {
          PropTrackAction: 'search_search-field_typing_start',
        });
        this.setState({ isTypingTracked: true });
      }
    }
    if (!this.props.isOpened && this.queryEl && this.queryEl.value !== '') {
      this.props.activate();
      ttt.event('PropTrackAction', {
        PropTrackAction: 'search_search-field_click',
      });
    }
  };

  listenForSubmit = event => {
    // if one item is highlighted do not submit the form
    // another handler takes care of redirecting to the selected item's url
    if (event.key === 'Enter' && this.props.highlightedIndex === null) {
      window.location.assign(
        this.props.searchLink({
          query: this.props.query,
          trackingKey: 'all_results_fallback',
        })
      );
    }

    if (event.key === 'Escape') {
      this.props.deactivate();
      this.setState({ isTypingTracked: false });
    }
  };

  handleFocus = () => {
    this.props.onFocus();
    if (!this.props.isOpened) {
      this.props.activate();
      ttt.event('PropTrackAction', {
        PropTrackAction: 'search_search-field_click',
      });
    }
  };

  handleBlur = () => {
    this.props.onBlur();
    this.setState({ isTypingTracked: false });
  };

  handleClickClear = e => {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.triggerInput) {
      this.props.triggerInput('');
    }
    this.props.deactivate();
    this.setState({ isTypingTracked: false });
    this.queryEl && this.queryEl.blur();
  };

  handleSearchSubmit = e => {
    e.stopPropagation();

    window.location.assign(
      this.props.searchLink({
        query: this.props.query,
        trackingKey: 'all_results_fallback',
      })
    );
  };

  handleSearchOpen = e => {
    e.stopPropagation();
    this.props.activate();
    this.queryEl && this.queryEl.focus();
  };

  render() {
    const {
      isOpened,
      className,
      styles,
      query = '',
      intl: { formatMessage },
    } = this.props;

    return (
      <form
        className={classNames(className, styles.searchSlot, {
          [styles.isOpened]: isOpened,
        })}
        action="#"
        onSubmit={e => e.preventDefault()}
      >
        <div className={styles.inputWrap}>
          <input
            {...this.props.getInputProps({
              'aria-label': formatMessage({
                id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER',
              }),
              className: styles.input,
              type: 'search',
              ref: ref => (this.queryEl = ref),
              placeholder: formatMessage({
                id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER',
              }),
              value: query,
              onKeyDown: this.listenForSubmit,
              onChange: this.handleChange,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
            })}
          />

          <button
            className={styles.clearButton}
            onMouseDown={this.handleClickClear}
            title={formatMessage({
              id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON',
            })}
          >
            <span className={styles.searchButtonInner}>
              <IconShapeCross className={styles.icon} />
            </span>
          </button>
        </div>
        <button
          className={styles.searchSubmitButton}
          onClick={this.handleSearchSubmit}
          title={formatMessage({
            id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON',
          })}
        >
          <span className={styles.searchButtonInner}>
            <IconCoreSearch className={styles.icon} />
          </span>
        </button>
        <button
          className={styles.searchOpenButton}
          onClick={this.handleSearchOpen}
          title={formatMessage({
            id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON',
          })}
        >
          <span className={styles.searchButtonInner}>
            <IconCoreSearch className={styles.icon} />
          </span>
        </button>
      </form>
    );
  }
}

export default withFlavourCSS(base, { odl, xdl })(injectIntl(SearchInput));
